require('rc-tooltip/assets/bootstrap_white.css');
require('./customTooltip.scss');
require('./customTooltip.override.scss');

// @ vendors
const React = require('react');
const { PureComponent } = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
import Tooltip from 'rc-tooltip';
// utilities

class CustomTooltip extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            tooltipVisible: false,
        };
    }

    handleTargetClick = () => {
        this.setState({ tooltipVisible: !this.state.tooltipVisible });
    };

    getAlignment() {
        const { disableAdjustment, offset } = this.props;
        const align = {
            offset,
        };

        if (disableAdjustment) {
            align['overflow'] = {
                adjustX: false,
                adjustY: false,
            };
        }

        return align;
    }

    buildBody() {
        const { content, modifier, title, type } = this.props;
        const contentClasses = classNames({
            'custom-tooltip__content-informative': type === 'informative',
            'custom-tooltip__content-explanatory': type === 'explanatory',
            'custom-tooltip__content-informative--dark-bg': type === 'informative' && modifier === 'dark-bg',
            'custom-tooltip__content-explanatory--dark-bg': type === 'explanatory' && modifier === 'dark-bg',
        });
        let titleEl;

        if (type === 'explanatory' && !!title) {
            const titleClasses = classNames('custom-tooltip__title', {
                'custom-tooltip__title--dark-bg': modifier === 'dark-bg',
            });

            titleEl = <h4 className={titleClasses}>{title}</h4>;
        }

        return (
            <div>
                {titleEl}
                <div className={contentClasses}>{content}</div>
            </div>
        );
    }

    buildTooltip() {
        const { modifier, type } = this.props;
        const body = this.buildBody();
        const classes = classNames('custom-tooltip__tooltip', {
            'custom-tooltip__tooltip--informative': type === 'informative',
            'custom-tooltip__tooltip--interactive': type === 'interactive',
            'custom-tooltip__tooltip--explanatory': type === 'explanatory',
            'custom-tooltip__tooltip--custom': type === 'custom',
            'custom-tooltip__tooltip--descriptive': type === 'descriptive',
            'custom-tooltip__tooltip--dark-bg': modifier === 'dark-bg',
        });

        return (
            <div className={classes} onClick={this.handleTargetClick}>
                {body}
            </div>
        );
    }

    render() {
        const { fixed, modifier, placement, target } = this.props;
        const { tooltipVisible } = this.state;
        const align = this.getAlignment();
        const contentEl = this.buildTooltip();
        const overlayClassName = classNames('custom-tooltip', {
            'custom-tooltip--dark-bg': modifier === 'dark-bg',
            'custom-tooltip--fixed': fixed,
        });
        const targetEl = React.cloneElement(target, {
            id: target.props.id,
            onClick: this.handleTargetClick,
        });
        const tooltipProps = {
            align,
            overlay: contentEl,
            overlayClassName,
            placement,
            trigger: ['click'],
            destroyTooltipOnHide: tooltipVisible,
        };

        return <Tooltip {...tooltipProps}>{targetEl}</Tooltip>;
    }
}

CustomTooltip.propTypes = {
    content: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    disableAdjustment: PropTypes.bool,
    fixed: PropTypes.bool,
    modifier: PropTypes.string,
    offset: PropTypes.array,
    placement: PropTypes.oneOf([
        'left',
        'right',
        'top',
        'bottom',
        'topLeft',
        'topRight',
        'bottomLeft',
        'bottomRight',
        'dom-align',
    ]),
    target: PropTypes.node.isRequired,
    title: PropTypes.string,
    type: PropTypes.oneOf(['custom', 'descriptive', 'explanatory', 'informative', 'interactive']),
};

CustomTooltip.defaultProps = {
    placement: 'topLeft',
    offset: [-20, -12],
    disableAdjustment: false,
};

export default CustomTooltip;
